<template>
    <div>
        <bita-breadcrumb :items="breadCrumbs"></bita-breadcrumb>
        <div class="wrapper wrapper-content animate fadeInRight">
            <bita-ibox :is-loading="isLoadingGrid">
                <div slot="body">
                    <bita-grid
                            ref="grid"
                            :columns="gridColumns"
                            :read-data="readData"
                            :hasRow="false"
                            :resizable="true"
                    />
                </div>
            </bita-ibox>
        </div>
        <view-modal
            ref="viewModal"
            :is-loading="isLoadingModal"
            :props-data="formData"
            modal-id="view-modal"
        />
    </div>
</template>
<script>
    import View from './View';

    export default {
    components: {"view-modal": View},
        data() {
            return {
                breadCrumbs:[
                    {title:"صفحه اصلی", link:"/"},
                    {title: "مدیریت بارنامه ها", link:"/cargo"}
                ],
                formData: {},
                isLoadingGrid: false,
                isLoadingModal: false,
                gridColumns:[
                    {title: "#", template: this.$getTemplate, width: "40px"},
                    {
                        field: "tracking_code",
                        title: "کد پیگیری",
                        template: (e) => e && e.tracking_code ? e.tracking_code : '---'
                    },
                    {
                        field: "request.origin.name",
                        title: "مبدا",
                        template: (e) => e && e.request && e.request.origin ? e.request.origin.name : '---',
                    },
                    {
                        field: "request.destination.name",
                        title: "مقصد",
                        template: (e) => e && e.request && e.request.destination ? e.request.destination.name : '---',
                    },
                    {
                        field: "state.name",
                        title: "وضعیت",
                        template: (e) => e && e.state ? e.state.name : '---'
                    },
                    {
                        title: "عملیات",
                        command: [],
                    }
                ]
            }
        },
        mounted() {
            this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
        },
        methods: {
            readData(e) {
                this.$resetGrid();
                this.isLoadingGrid = true;
                this.$persistClient('get', 'cargoes?include=state,request_detail,request.origin,request.destination')
                .then((res) => {
                    e.success(res.data)
                })
                .catch((res) => {
                    e.success([])
                })
                .finally((res) => {
                    this.isLoadingGrid = false;
                })
            },
            gridCommands(){
                let commands = [];
                commands.push({
                    text: "view",
                    click: this.view,
                    template: this.gridButtons.view
                });
                commands.push({
                    text: "edit",
                    click: this.edit,
                    template: this.gridButtons.edit,
                });
                commands.push({
                    text: "delete",
                    click: this.delete,
                    template: this.gridButtons.delete,
                });
                return commands;
            },
            view(e){
                let cargo = this.$refs.grid.getSelectedGridRow(e);
                $("#view-modal")
                    .modal({
                        backdrop: "static",
                        keyboard: false,
                    })
                    .modal("toggle");
            },
            edit(e){
                let cargo = this.$refs.grid.getSelectedGridRow(e);
            },
            delete(e){
                let cargo = this.$refs.grid.getSelectedGridRow(e);
            }
        }
    }
</script>